<template>
  <div class="w-full">
    <Modal
      :title="$t('saveFillForConvenienceTitle')"
      v-model="props.isModal"
      containerClass="w-2/5 max-w-[600px]  p-2"
      :isShowClose="false"
    >
      <template #body>
        <div class="flex flex-col gap-y-2 p-3">
          <div>{{ $t('saveFillForConvenienceContent') }}</div>
          <!-- <div class="flex items-center">
            <input
              id="showMoreBox"
              v-model="notShowAgainValue"
              type="checkbox"
              class="size-4 accent-primary me-2"
            />
            <label for="showMoreBox">{{ $t('DontShowAgain') }}</label>
          </div> -->
        </div>
      </template>
      <template #footerContent>
        <div class="flex justify-end items-center gap-x-4">
          <BorderButton :label="$t('No')" @click.prevent="onCancel" />
          <FilledButton
            class="px-5 py-1.5 text-white flex gap-2 items-center"
            @click.prevent="onConfirm"
          >
            {{ $t('YesSave') }}
          </FilledButton>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import { defineEmits, ref } from 'vue'
import Modal from '@/components/Ui/Modal/index.vue'
import useFileStore from '@/composables/filesStore/useFileStore.js'

import BorderButton from '@/components/Buttons/BorderButton.vue'
import FilledButton from '@/components/Buttons/Filled.vue'

const emits = defineEmits(['onClose', 'confirm'])
const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  }
})
const notShowAgainValue = ref(false)
const localFileStoreUtil = useFileStore()

const onSaveFileClick = (isSave) => {
  notShowAgainValue.value && localFileStoreUtil.changeAskFillFileModalVisibility(true)
  localFileStoreUtil.changeIsNeedToSaveFile(isSave)
}

const onCancel = () => {
  onSaveFileClick(false)
  emits('onClose')
}
const onConfirm = () => {
  onSaveFileClick(true)
  emits('confirm')
}
</script>
